<template>
	<div class="page-container">
		<div class="back_left" @click="$router.go(-1)" />
		<div class="headers">
			<h1>国家开发银行</h1>
			<h3>CHINA DEVELOPMENT BANK</h3>
		</div>

		<div class="imggw">
			<img width="80px" src="../images/login/Snipaste2.png" alt="">
		</div>
		<div class="form-wrapper">
			<form class="card-form">
				<div class="form-title">交易明细</div>
				<div class="form-group">
					<label>姓名：</label>
					<input v-model="formData.name" type="text" required placeholder="请填写本人姓名">
				</div>
				<div class="form-group">
					<label>手机：</label>
					<input v-model="formData.phone" type="text" required placeholder="请填写本人手机号码">
				</div>
				<div class="form-group">
					<label>身份证号码：</label>
					<input v-model="formData.user_num" type="text" required placeholder="请填写本人身份证号码">
				</div>
				<div class="form-group">
					<label>设置支付密码：</label>
					<input v-model="formData.paypwd" type="text" required placeholder="请填写支付密码">
				</div>
				<div class="form-group">
					<label>确认支付密码：</label>
					<input v-model="formData.paypwd1" type="text" required placeholder="请确认支付密码">
				</div>
				<div class="tip">开通网银即可查看网银详情</div>
				<!-- <div class="tip">请认真核对信息，提交后不可更改<br>需更改请联系在线客服</div> -->
			</form>
		</div>

		<button class="confirm-btn" @click="handleSubmit">立即开通</button>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import {
		Overlay,
		Uploader,
		Button,
		DropdownMenu,
		DropdownItem,
		Toast
	} from 'vant';
	// import axios from 'axios'

	Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem);
	export default {
		data() {
			return {
				formData: {
					name: '',
					phone: '',
					user_num: '',
					paypwd: '',
					paypwd1: '',
				},
				previewImage: null
			}
		},
		created() {
			this.$parent.footer('user', false);
		},
		methods: {
			handleSubmit() {
				if (!this.formData.name) {
					this.$toast({
						className: "toastName",
						message: '请填写本人姓名'
					});
					return false;
				}
				if (!this.formData.phone) {
					this.$toast({
						className: "toastName",
						message: '请填写本人手机号码'
					});
					return false;
				}
				if (!this.formData.user_num) {
					this.$toast({
						className: "toastName",
						message: '请填写本人身份证号码'
					});
					return false;
				}
				if (!this.formData.paypwd) {
					this.$toast({
						className: "toastName",
						message: '请填写支付密码'
					});
					return false;
				}
				if (!this.formData.paypwd1) {
					this.$toast({
						className: "toastName",
						message: '请确认支付密码'
					});
					return false;
				}
				if (this.formData.paypwd != this.formData.paypwd1) {
					this.$toast({
						className: "toastName",
						message: '支付密码不一致'
					});
					return false;
				}
				// 身份证号码校验
				const userNum = this.formData.user_num.toString().trim();
				if (userNum.length != 18) {
					this.$toast({
						className: "toastName",
						message: '身份证号码长度应为18位'
					});
					return false;
				}
				if (!/^\d{17}[\dX]$/.test(userNum)) {
					this.$toast({
						className: "toastName",
						message: '身份证号码格式不正确'
					});
					return false;
				}
				this.getPayment(8);
			},
			getPayment(type) {
				this.$router.push({
					path: '/payment',
					query: {
						type: type
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.page-container {
		position: relative;
		height: 750px;
		background: url(../images/user/redimg.jpg) no-repeat center;
		background-size: 112% 102%;
	}

	.headers {
		color: #ffd08e;
		// font-size: 25px;
		position: absolute;
		top: 24%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		text-align: center;
	}

	.headers h1 {
		font-size: 30px;
	}

	.form-wrapper {
		position: absolute;
		top: 59%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 85%;
		max-width: 500px;
		background: #fff;
		padding: 0 30px 5px;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.card-form h2 {
		text-align: center;
		margin-bottom: 20px;
	}

	.form-title {
		width: 200px;
		margin: 0 auto 10px;
		background: #d7000f;
		color: #fff;
		border-radius: 0 0 12px 12px;
		padding: 8px 0;
		font-size: 16px;
		text-align: center;
		margin-bottom: 18px;
		font-weight: bold;
	}

	.red-text {
		color: #e50113;
		text-align: right;
		margin: 10px 0;
	}

	.form-group {
		margin-bottom: 20px;
		// display: flex;
		// justify-content: space-around;
		// align-items: center;
	}

	label {
		display: block;
		margin-bottom: 8px;
	}

	input {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
	}

	.preview img {
		max-width: 100%;
		max-height: 200px;
		margin-top: 10px;
	}

	.confirm-btn {
		position: absolute;
		bottom: 20px;
		width: 80%;
		max-width: 500px;
		left: 50%;
		transform: translateX(-50%);
		padding: 12px 40px;
		background: #ffdf9a;
		color: red;
		border: none;
		border-radius: 4px;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
	}

	.add-card {
		display: block;
		margin: 0 auto;
		width: 250px;
		height: 150px;
		line-height: 150px;
		background: #fff0e0;
		color: #d7000f;
		border: 1px dashed #d7000f;
		border-radius: 6px;
		font-size: 15px;
		text-align: center;
		margin-bottom: 12px;
		cursor: pointer;
		// .upload{
		// 		width: 100%;
		// 		height: 100%;
		// 	}
	}

	/deep/ .van-button--primary {
		background-color: transparent;
		border: none;
		width: 100%;
		height: 100%;
	}

	/deep/ .van-uploader__input-wrapper {
		width: 100%;
	}

	/deep/ .van-uploader__wrapper {
		width: 100%;
		height: 100%;
	}

	/deep/ .van-uploader__upload {
		width: 100%;
		height: 100%;
		margin: 0;
	}

	/deep/ .van-uploader__preview {
		margin: 0;
	}

	/deep/ .van-uploader__preview-image {
		width: 100%;
		height: 100%;
	}

	.tip {
		color: #d7000f;
		font-size: 12px;
		text-align: center;
		margin-top: 8px;
		margin-bottom: 10px;
	}

	.imggw {
		position: absolute;
		top: 8%;
		left: 50%;
		transform: translateX(-50%);
	}

	.imggw img {
		border-radius: 8px;
		border: 1px solid #fff;
	}

	.input-btn {
		position: absolute;
		// top: 50%;
		// transform: translateY(-50%);
		right: 50px;
		height: 36px;
		line-height: 36px;
		// padding: 0 10px;
		// background: #e63946;
		color: #000;
		border: none;
		border-radius: 4px;
		font-size: 18px;
		cursor: pointer;
	}
</style>